import { Card, Divider, Typography, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { getProgramsList } from '../../../../../../redux/slices/transitions';
import FormFacilityProgramsField from '../../../FormFields/FormFacilityProgramsField';
import { CLINICAL } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormNumberField from '../../../FormFields/FormNumberField';
import FormTitle from '../../../FormFields/FormTitle';

FacilityProgramsForm.propTypes = { permissions: PropTypes.object };

export default function FacilityProgramsForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);
  const dispatch = useDispatch();
  const { watch } = useFormContext();

  const companyId = watch('companyId');

  const {
    data: { programs = {} },
  } = useSelector((state) => state.transitions);
  const dbProgramOptions = programs?.[companyId] ?? [];

  useEffect(() => {
    if (companyId && !programs?.[companyId]) dispatch(getProgramsList(companyId));
  }, [companyId, programs, dispatch]);

  const showForm = [CLINICAL.PROGRAMS, CLINICAL.WAIVED_TESTS_PER_YEAR, CLINICAL.NOT_WAIVED_TESTS_PER_YEAR].some(
    ({ id }) => id in permissions
  );

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Facility Programs
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {CLINICAL.PROGRAMS.id in permissions && (
            <Grid item xs={12}>
              <FormTitle fieldAttributes={{ questionTitle: 'Facility programs' }} />
              <FormFacilityProgramsField
                fieldName={CLINICAL.PROGRAMS.fieldName}
                dbProgramOptions={dbProgramOptions}
                isEditable={permissions[CLINICAL.PROGRAMS.id]}
              />
            </Grid>
          )}
          {CLINICAL.WAIVED_TESTS_PER_YEAR.id in permissions && (
            <Grid item xs={12} md={6}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'Volume of waived tests per year' }} />
                <FormNumberField
                  fieldName={CLINICAL.WAIVED_TESTS_PER_YEAR.fieldName}
                  fieldAttributes={{ isEditable: permissions[CLINICAL.WAIVED_TESTS_PER_YEAR.id] }}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                />
              </FieldContainer>
            </Grid>
          )}
          {CLINICAL.NOT_WAIVED_TESTS_PER_YEAR.id in permissions && (
            <Grid item xs={12} md={6}>
              <FieldContainer>
                <FormTitle fieldAttributes={{ questionTitle: 'Volume of not waived tests per year' }} />
                <FormNumberField
                  fieldName={CLINICAL.NOT_WAIVED_TESTS_PER_YEAR.fieldName}
                  fieldAttributes={{ isEditable: permissions[CLINICAL.NOT_WAIVED_TESTS_PER_YEAR.id] }}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                />
              </FieldContainer>
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
